import { useGlobalData } from "@/app/global_data"

type FilterCurrentStatusProps = {
  memberTextContent?: string
  className?: string
}

export function FilterCurrentStatus({
  className,
  memberTextContent,
}: FilterCurrentStatusProps) {
  const { filter, entity, entityValues, allValues, comparison, chart, term } =
    useGlobalData().get()

  const isFund = entity.isFund()

  // const totalMembers = useMemo(() => {
  //   if (comparison.isPeers()) {
  //     return entityValues?.[isFund ? "fundsets" : "firmsets"]?.peers?.members
  //       .length
  //   }

  //   if (comparison.isCustomList()) {
  //     return entityValues?.[isFund ? "fundsets" : "firmsets"]?.customMetrics
  //       ?.members.length
  //   }

  //   if (comparison.isAll()) {
  //     return allValues?.[isFund ? "fundsets" : "firmsets"]?.[
  //       isFund ? "category" : "industry"
  //     ]?.members.length
  //   }

  //   if (comparison.isTop10()) {
  //     const top10Members = allValues?.top10?.[chart.top10Metric.name]?.members
  //     if (top10Members) {
  //       if (term.isPeriodic) {
  //         return top10Members?.periodic?.length
  //       } else {
  //         return top10Members?.ranking?.[term.key]?.length
  //       }
  //     }
  //   }
  // }, [entity, entityValues, allValues, comparison])

  // const filteredMembers = useMemo(() => {
  //   if (comparison.isPeers()) {
  //     return entityValues?.[isFund ? "fundsets" : "firmsets"]?.peers
  //       ?.filterCount
  //   }

  //   if (comparison.isCustomList()) {
  //     return entityValues?.[isFund ? "fundsets" : "firmsets"]?.customMetrics
  //       ?.filterCount
  //   }

  //   if (comparison.isAll()) {
  //     return allValues?.[isFund ? "fundsets" : "firmsets"]?.[
  //       isFund ? "category" : "industry"
  //     ]?.filterCount
  //   }

  //   if (comparison.isTop10()) {
  //     const top10Members = allValues?.top10?.[chart.top10Metric.name]?.members
  //     if (top10Members) {
  //       if (term.isPeriodic) {
  //         return top10Members?.periodic?.filter(
  //           (member) => member.filterIncluded
  //         )?.length
  //       } else {
  //         return top10Members?.ranking?.[term.key]?.filter(
  //           (member) => member.filterIncluded
  //         )?.length
  //       }
  //     }
  //   }
  // }, [entity, entityValues, allValues, comparison])

  const memberTotalAmountText =
    filter.description === "No description" ? filter.name : filter.description

  return (
    <p className={`block h-1 ${className} text-2xs font-normal italic`}>
      {memberTotalAmountText}
    </p>
  )
}
